/**
 * The group letters a classroom can carry ("3°A" … "3°M"). Some schools run
 * groups up to M; the picker offered only A–F until 2026-10-06. The backend
 * stores any short string (`Classroom.section`, max_length=10): this is the
 * picker's list, not a server enum, so it lives here and nowhere else.
 */
export const CLASSROOM_SECTIONS = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
] as const
